export enum PartnerTransferSection {
  PartnerTransfer = 'PartnerTransfer',
  Investments = 'Investments',
  Expenses = 'Expenses',
  Income = 'Income',
  Fees = 'Fees',
  LinkedCapitalActions = 'LinkedCapitalActions',
  GeneralCapitalActions = 'GeneralCapitalActions',
  Summary = 'Summary',
}

export enum PartnerTransferTypes {
  PartnerTransfer = 'partnerTransfer',
}
